import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgRebookTransfer({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      width={16}
      height={17}
      fill="none"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fillRule="evenodd" clipRule="evenodd">
        <path
          d="M7.2.2a3.75 3.75 0 012.05 6.89c.6.205 1.129.478 1.505.788A.75.75 0 119.8 9.035C9.262 8.592 8.047 8.2 6.95 8.2c-2.584 0-4.75 2.351-4.75 5.25a.75.75 0 01-1.5 0c0-2.988 1.831-5.552 4.348-6.428A3.75 3.75 0 017.2.2zm0 1.5a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z"
          fill="#666"
        />
        <path
          d="M13.43 9.458a.8.8 0 00-1.178 1.084l1.066 1.158H8.2a.8.8 0 000 1.6h5.118l-1.066 1.158a.8.8 0 101.178 1.084l2.3-2.5a.8.8 0 000-1.084l-2.3-2.5z"
          fill="#FF8066"
        />
      </g>
    </svg>
  );
}

SvgRebookTransfer.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgRebookTransfer.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgRebookTransfer svgRef={ref} {...props} />);
export default ForwardRef;
